"use strict";
var unitas = unitas || {};

const getOfferForm = document.getElementsByClassName("form-get-offer")[0];
const modal = document.getElementById("js-side-modal-get-offer");

unitas.getofferform =
  unitas.getofferform ||
  (function () {
    function init() {
      if (modal && getOfferForm) {
        const travelName = modal.dataset.travelName;
        const travelNameField = getOfferForm.querySelector(
          'input[id$="turnavn"]'
        );
        if (travelNameField) {
          travelNameField.value = travelName;
          travelNameField.readOnly = true;
        }
      }
    }

    return {
      init: init,
    };
  })();
